module.exports = __webpack_public_path__ + "assets/media/morning.3543ec29.mp3";